import { createReducer } from 'typesafe-actions';
import { put, cancelled, call, select } from 'redux-saga/effects';
import { api } from 'api';
import { getArticle, getRegionCode } from 'common/selectors';
import { CancelTokenSource } from '@okapi/http';
import log from 'loglevel';
import { CallEffectReturnType, EffectR } from 'types/utils';
import { getPrimaryPriceUnitSlug, getProductModelId } from 'features/product-info';
import { ViewsModels } from '../types';
import { FETCH_MEASUREMENT_SETTINGS } from './actions';
import { fetchMeasurementSettings } from './api';

export const measurementSettings = createReducer<ViewsModels.MeasurementSettings | null>(null)
  .handleAction(FETCH_MEASUREMENT_SETTINGS.success, (_, { payload }) => payload)
  .handleAction(FETCH_MEASUREMENT_SETTINGS.failure, () => ({ step: 1 }));

export function* doFetchMeasurementSettings() {
  const productId = (yield select(getArticle)) as EffectR.Select<typeof getArticle>;
  const modelId = (yield select(getProductModelId)) as EffectR.Select<typeof getProductModelId>;
  const unitOfsale = (yield select(getPrimaryPriceUnitSlug)) as EffectR.Select<
    typeof getPrimaryPriceUnitSlug
  >;
  const regionCode = (yield select(getRegionCode)) as EffectR.Select<typeof getRegionCode>;

  const abortController: CancelTokenSource = yield call([api, 'abortController']);
  yield put(FETCH_MEASUREMENT_SETTINGS.request());

  try {
    const settings = (yield call(
      fetchMeasurementSettings,
      { productId, regionCode, modelId, unitOfsale },
      {
        cancelToken: abortController.token,
      },
    )) as CallEffectReturnType<typeof fetchMeasurementSettings>;
    yield put(FETCH_MEASUREMENT_SETTINGS.success(settings));
  } catch (e) {
    if (e instanceof Error) {
      yield put(FETCH_MEASUREMENT_SETTINGS.failure(e));
    } else {
      yield put(FETCH_MEASUREMENT_SETTINGS.failure(new Error(String(e))));
    }
  } finally {
    if ((yield cancelled()) as boolean) {
      abortController.cancel();
      yield call(log.info, 'fetchMeasurementSettings was cancelled');
      yield put(FETCH_MEASUREMENT_SETTINGS.cancel());
    }
  }
}
